import React, {createContext, useReducer} from 'react'
import {AssociateFilterReducerV2} from "../reducers/AssociateFilterReducerV2";

export const AssociateFilterContextV2 = createContext();

const AssociateFilterContextProvider = (props) => {
    const [states, dispatch] = useReducer(AssociateFilterReducerV2, []);
    return (
        <AssociateFilterContextV2.Provider value={{states, dispatch}}>
            {props.children}
        </AssociateFilterContextV2.Provider>
    )
}

export default AssociateFilterContextProvider


// WEBPACK FOOTER //
// ./src/components/outboundassociate/context/AssociateFilterContextV2.js